var unformat = function unformat(price) {
  if (price === void 0) {
    price = '';
  }
  return Number(String(price).replace(/[^0-9.-]+/g, ''));
};

export { unformat as default };
//# sourceMappingURL=unformat.js.map
